module.exports = __webpack_public_path__ + "static/media/start-stop.f508fe30.ogg";